export const validateEmail = (email) => {
  return email.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/);
}

export const validatePhone = (phone) => {
  return phone.match(/^\d{9,}$/);
}

export const validateContactForm = (t, data) => {
  const errorList = {};

  // Name
  if (!data.name) {
    errorList.name = t('contact.name.invalid');
  }

  // Surname
  if (!data.surname) {
    errorList.surname = t('contact.surname.invalid');
  }

  // Email
  if (!data.email || !validateEmail(data.email)) {
    errorList.email = t('contact.email.invalid');
  }

  // Phone
  if (data.phone && !validatePhone(data.phone)) {
    errorList.phone = t('contact.phone.invalid');
  }

  // Privacy
  if (!data.privacy) {
    errorList.privacy = t('contact.privacy.invalid');
  }

  return { isValid: Object.keys(errorList).length === 0, invalidFields: errorList };
};